import { getClassNames } from '@websolutespa/bom-core';
import { LlmBlock, LlmChunkImage } from '../../../types';
import style from './image.module.scss';

export const Image: React.FC<LlmBlock<LlmChunkImage>> = (props) => {
  const { item } = props;
  const classNames = getClassNames(style.root, 'llm__image', { [`llm__image--${item.type}`]: !!item.type });
  return (
    <div className={classNames}>
      {item.url ? (
        <div className="llm__row">
          <div className="llm__col --end-xs-12 --xs-10 --sm-9 --md-8 --lg-7 --xl-6">
            <img className={style.image} src={item.url} alt="" />
          </div>
        </div>
      ) : (
        <pre className={classNames}>{JSON.stringify(item, null, 2)}</pre>
      )}
    </div>
  );
};
